module.exports = __webpack_public_path__ + "static/media/thermal-dark.1e07c632.svg";